// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/index.css
// module id = 1590
// module chunks = 81